// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2Kd8r","dragIcon":"SortableItem_dragIcon__3U4eC","disabled":"SortableItem_disabled__2YUCb"};